import axios from "axios";

const VUE_APP_ASURAPI_AIM = process.env.VUE_APP_ASURAPI_AIM;

export default {
  async sendChangePassword(email, newPassword) {
    try {
      const response = await axios.post(
        `${VUE_APP_ASURAPI_AIM}cliente/kafka/change-password`,
        {
          email,
          newPassword
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error enviando mensaje a Kafka:", error);
      throw error;
    }
  }
};